module.exports = __webpack_public_path__ + "img/picto-calendar.5f2d2701.svg";